import { ICalendarEvent, IParticipant, IReminder } from 'APP/model/calendar/calendar.types';

export interface IEventCalendar extends ICalendarEvent {
  isTemplate?: boolean;
  isSelected?: boolean;
}

export interface IContentGridCalendarEvent extends IEventCalendar {
  displayEnd: Date;
  displayStart: Date;
}

export interface IUpdateEvent {
  title?: string;
  allDay?: boolean;
  start?: Date;
  end?: Date;
  description?: string;
  recurrenceType?: string;
  participants?: IParticipant[];
  reminders?: IReminder[];
}

export enum ActiveSidebarView {
  Create = 'Create',
  Edit = 'Edit',
  Info = 'Info',
  Empty = '',
}

export type IRange = { start: Date; end: Date } | Date[];
